import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'next-i18next';
import Button from '../../atoms/Button/Button';

import styles from './ContactBanner.module.scss';
import cn from '../../../src/utils/cn';

function ContactBanner({ dark }) {
  const { t } = useTranslation();

  return (
    <div
      className={cn([
        styles.contact,
        dark ? styles.dark : '',
        'flex a-center j-spb m-t-20 mobile-d-col mobile-j-center',
      ])}
    >
      <div className="p-r-40 mobile-p-r-0 mobile-text-center">
        <h3 className="fs-20 fw-500 text-c-primary m-b-10">
          {t('camp.details.contact.title')}
        </h3>
        <div
          className="text-c-primary fw-400"
          dangerouslySetInnerHTML={{ __html: t('camp.details.contact.text') }}
        />
      </div>
      <div className="mobile-m-t-20">
        <a href="mailto:camps@mouratoglou.com" className="no-hover" target="_blank" rel="noreferrer">
          <Button
            text="uppercase"
            size="small"
          >
            {t('camp.details.contact.cta')}
          </Button>
        </a>
      </div>
    </div>
  );
}

ContactBanner.propTypes = {
  dark: PropTypes.bool,
};

ContactBanner.defaultProps = {
  dark: false,
};

export default ContactBanner;
